import { findCar } from '@racedash/shared'
import { Datum, NoValue, Tile } from '../Tile'
import type { WidgetProps } from './props'

export default function LapNumber({ car, data }: WidgetProps<'lapNumber'>) {
  const lap = findCar(data.standings, car)?.lap

  return <Tile label="Lap">{lap && lap > 0 ? <Datum value={lap} /> : <NoValue />}</Tile>
}
